export class DataNotAvailableError extends Error {
}
